module.exports = __webpack_public_path__ + "static/img/02.9aea7a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/02.png
// module id = 8Oed
// module chunks = 2